var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    width: 45,
    height: 45,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m507.606 486.394-46.039-46.039c6.653-4.35 12.521-9.926 17.284-16.561 10.124-14.103 14.114-31.434 11.235-48.802-3.838-23.162-21.006-43.031-43.735-50.619-6.386-2.133-12.91-3.265-19.392-3.365-5.744-.09-16.391-1.352-23.148-8.799-11.257-12.403-26.51-19.725-42.812-20.989v-145.22c0-8.284-6.716-15-15-15h-125.204c.111-1.411.185-2.83.201-4.259.238-21.258-11.177-41.692-30.536-54.663-7.903-5.295-16.146-8.729-24.5-10.208-6.06-1.072-11.504-4.955-15.33-10.934-13.995-21.863-39.698-33.26-65.49-29.049-10.553 1.727-20.617 6.258-29.132 12.907l-30.402-30.4c-4.289-4.291-10.742-5.572-16.346-3.252-5.606 2.322-9.26 7.791-9.26 13.858v482c0 8.284 6.716 15 15 15h482c6.067 0 11.536-3.654 13.858-9.26 2.322-5.605 1.038-12.056-3.252-16.346zm-126.009-154.024c10.646 11.731 26.59 18.349 44.897 18.634 3.404.053 6.889.667 10.356 1.824 12.317 4.112 21.597 14.737 23.641 27.069 2.763 16.672-6.198 32.266-21.017 38.364l-78.474-78.474v-18.437c7.857 1.116 15.031 4.888 20.597 11.02zm-50.597-171.37v148.787l-29.666-29.666c6.289-10.155 9.666-21.876 9.666-34.121 0-35.841-29.159-65-65-65-12.245 0-23.965 3.377-34.121 9.666l-14.649-14.649c5.22-4.301 9.724-9.38 13.37-15.016h120.4zm-52.019 96.768-44.749-44.749c3.727-1.326 7.695-2.019 11.768-2.019 19.299 0 35 15.701 35 35 0 4.074-.692 8.041-2.019 11.768zm-188.999-206.273c14.18-2.321 27.731 3.665 35.38 15.614 8.397 13.12 20.958 21.751 35.367 24.302 4.287.759 8.551 2.588 13.033 5.59 10.917 7.314 17.359 18.307 17.235 29.403-.128 11.375-5.978 21.855-15.174 28.207l-98.33-98.331c3.836-2.409 8.09-4.065 12.489-4.785zm-59.982 430.505v-430.787l430.787 430.787z",
    fill: "currentColor",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 166,
    r: 15,
    fill: "currentColor",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 296,
    r: 15,
    fill: "currentColor",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 426,
    r: 15,
    fill: "currentColor",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 426,
    r: 15,
    fill: "currentColor",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 426,
    r: 15,
    fill: "currentColor",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 366,
    r: 15,
    fill: "currentColor",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 236,
    r: 15,
    fill: "currentColor",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 306,
    r: 15,
    fill: "currentColor",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 366,
    r: 15,
    fill: "currentColor",
    "data-original": "#000000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalad);
export default __webpack_public_path__ + "static/media/salad.04db8e621e0e116149cca3851c268f1b.svg";
export { ForwardRef as ReactComponent };